import { render, staticRenderFns } from "./InvoicingRules.vue?vue&type=template&id=6d50bca7&scoped=true&"
import script from "./InvoicingRules.vue?vue&type=script&lang=js&"
export * from "./InvoicingRules.vue?vue&type=script&lang=js&"
import style0 from "./InvoicingRules.vue?vue&type=style&index=0&id=6d50bca7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d50bca7",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBtn,VCol,VContainer,VIcon,VRow,VSkeletonLoader,VSnackbar})


/* hot reload */
if (module.hot) {
  var api = require("/working_dir/management-portal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d50bca7')) {
      api.createRecord('6d50bca7', component.options)
    } else {
      api.reload('6d50bca7', component.options)
    }
    module.hot.accept("./InvoicingRules.vue?vue&type=template&id=6d50bca7&scoped=true&", function () {
      api.rerender('6d50bca7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/InvoicingRules.vue"
export default component.exports